// extracted by mini-css-extract-plugin
export default {"container":"pixel_container__wpjaN"};